@import '../../global/base.scss';


@import "./font.scss";
@import "./ticom.header.subpage.scss";
@import "./ticom.global.responsive.scss";

#menu_parent {
  background: #333333;
  display: flex;
  height: 42px;
  width: 100%;
  top: 110px;
  z-index: 1;
 }


gc-widget-authentication {
  --theme-menu-color: #007c8c;
  margin-bottom:0px;
}

#ti_header-top-llc {
  margin-bottom:0px;
}

#product-container {
  --gc-menu-product-font-size: 16px;
}

.ti_header-top {
  max-width: 1200px;
  justify-content: space-between;
  align-items: center;
  padding-inline: 0px;
}

gc-widget-menubar {
  max-width: $section-max-width;
  --gc-widget-menubar-product-font-size: 16px;
  background: #333333;
  margin-left: auto;
  margin-right: auto;
}

#search_bar_container {
  display: flex;
  align-items: center;

  #search_input_bar {
    padding-right: 0px;
    margin-right: 0px;
    border-right: 0px;
    width: 300px;
    caret-color: #000000;
    margin: 0px;
    height:auto;  
  }


  #search_icon_button {
    background-color: #ffffff;
    padding: 3px 3px 2px 3px;
    margin-left: 0;
    border-top: 1px solid var(--gc-border-color, var(--theme-border-color, #e5e5e5));
    border-bottom: 1px solid var(--gc-border-color, var(--theme-border-color, #e5e5e5));
    border-right: 1px solid var(--gc-border-color, var(--theme-border-color, #e5e5e5));
    border-left: none;
  }
  #search_icon_button:hover {
    --gc-color: #007c8c;
    cursor: pointer;
  }
}

gc-widget-menuitem {
  --theme-menu-background-color:#333333;
  --theme-menu-color: #f7f7f7;
}

gc-widget-menuaction {
  --gc-background-color-hover:#333333; 
}


#page_root {
  display: flex;
  flex-direction: column;
  position: relative;
}

#page_container {
  display: flex;
  flex: 1 1 auto;
  flex-flow: column;
  * {
    margin: 0;
  }
}

#announcement_container {
  background: $section-background-color;

  #announcement {
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }
}
